module.exports = __webpack_public_path__ + "static/media/male08.49d33708.jpg";